export function normalizeWorkPackageName(name) {
    return name?.trim() ?? ""
}

export function normalizeWorkPackageDescription(description) {
    return description?.trim() ?? ""
}

export function getDuplicateWorkPackageNameError(name, { normalize = true } = {}) {
    const errorName = normalize ? normalizeWorkPackageName(name) : name
    return `A work package with the name "${errorName}" already exists`
}

export function isDuplicateWorkPackageNameError(message) {
    return message?.startsWith('A work package with the name "') && message?.endsWith('" already exists')
}
